<div class="content-title-container" *ngIf="title">
  <p class="content-title">{{ title }}</p>
</div>
<div #content [class.fill-space]="content.children.length">
  <ng-content></ng-content>
</div>
<div *ngIf="!content.children.length" class="padded logo-section">
  <div class="placeholder-logo-container">
    <img src="assets/img/logo.svg" alt="Lingon logo" />
  </div>
</div>
